module.exports = __webpack_public_path__ + "7dce72a3e04407d73364df0b4ffa407f.png";